export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Final (2)_03.43532462.jpg";